import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminAuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-forbidden',
  template: `
    <div class="flex min-h-screen flex-col items-center justify-center bg-zinc-950 text-center font-sans px-4">
      <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-red-950 mb-6">
        <lucide-icon name="shield" [size]="28" class="text-red-500" [strokeWidth]="1.5"></lucide-icon>
      </div>
      <h1 class="text-2xl font-semibold text-white">Access Denied</h1>
      <p class="mt-3 max-w-sm text-sm text-zinc-400">
        Your account is not in the <span class="font-mono text-zinc-300">Admins</span> group.
        Contact your platform administrator to request access.
      </p>
      <div class="mt-8 flex gap-3">
        <button
          (click)="signOut()"
          class="rounded-lg border border-zinc-700 px-4 py-2 text-sm font-medium text-zinc-300 transition-colors hover:bg-zinc-800"
        >
          Sign out
        </button>
      </div>
    </div>
  `,
})
export class ForbiddenComponent {
  constructor(
    private readonly auth: AdminAuthService,
    private readonly router: Router,
  ) {}

  async signOut(): Promise<void> {
    await this.auth.signOut();
    await this.router.navigate(['/login']);
  }
}
